import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http.service';
import { AttachmentConfig } from '@core/config/attachment-config';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsService {
  constructor(private http: HttpService) {
     // This is intentional
  }

  getAttachmentReferral(referralid) {
    return this.http.get(AttachmentConfig.EndPoint.Attachments.GetAttachmentReferral + '/' + referralid);
  }
  getCategoryLookup(name) {
    return this.http.get(AttachmentConfig.EndPoint.Attachments.GetCategoryLookup + '/' + name);
  }
  uploadKey(objparams) {
    return this.http.post(AttachmentConfig.EndPoint.Attachments.UploadKey, objparams);
  }
  downloadKey(objparams) {
    return this.http.post(AttachmentConfig.EndPoint.Attachments.DownloadKey, objparams);
  }
  postAttachment(objparams) {
    return this.http.post(AttachmentConfig.EndPoint.Attachments.PostAttachment, objparams);
  }
  putAttachment(objparams, attachmentId) {
    console.log(AttachmentConfig.EndPoint.Attachments.PutAttachment + '/' + attachmentId, objparams);
    return this.http.patch(AttachmentConfig.EndPoint.Attachments.PutAttachment + '/' + attachmentId, objparams);
  }
}
